import { getDecodedUserAccessTokenFromBrowserCookies } from "../../legacy/services/authentication-service/stores/access-token/get-decoded-user-access-token-from-browser-cookies/get-decoded-user-access-token-from-browser-cookies";

export const DEFAULT_QA_ACCOUNT_EMAIL_MARKERS: readonly string[] = [
  "michele.giordano",
  "kristina.poberezhna",
  "filippo.mussoni",
  "bx.e2e.test",
  "testuser12767",
];

export function parseQaAccountEmailMarkers(
  rawValue: string | undefined,
  defaultMarkers: readonly string[] = DEFAULT_QA_ACCOUNT_EMAIL_MARKERS
): string[] {
  if (rawValue === undefined) return [...defaultMarkers];

  return rawValue
    .split(",")
    .map(function trimMarker(marker) {
      return marker.trim().toLowerCase();
    })
    .filter(Boolean);
}

export function isQaAccountEmail(email: string | undefined, emailMarkers: readonly string[]): boolean {
  if (!email) return false;

  const normalizedEmail = email.toLowerCase();
  return emailMarkers.some(function matchesMarker(marker) {
    return normalizedEmail.includes(marker);
  });
}

export const qaAccountEmailMarkers = parseQaAccountEmailMarkers(process.env.REACT_APP_QA_ACCOUNT_EMAILS);

export function resolveQaAccountSessionFromAccessToken(): boolean {
  return isQaAccountEmail(getDecodedUserAccessTokenFromBrowserCookies()?.account?.email, qaAccountEmailMarkers);
}

// Seeded from the access-token cookie so Mixpanel and Sentry know before the account request resolves
let isQaAccountSession = resolveQaAccountSessionFromAccessToken();

export function markQaAccountSession(email: string | undefined): void {
  isQaAccountSession = isQaAccountEmail(email, qaAccountEmailMarkers);
}

export function isQaAccountSessionActive(): boolean {
  return isQaAccountSession;
}

export function clearQaAccountSession(): void {
  isQaAccountSession = false;
}
